export const PREINSCRIPTION_VALIDEE_ACCESS_KEY =
  "op-biscuit-ferrero-preinscription-validee";

export const PERDU_ACCESS_KEY = "op-biscuit-ferrero-perdu";

export function hasPreinscriptionValideeAccess() {
  return sessionStorage.getItem(PREINSCRIPTION_VALIDEE_ACCESS_KEY) === "1";
}

export function hasPerduAccess() {
  return sessionStorage.getItem(PERDU_ACCESS_KEY) === "1";
}
